import { AccountDetails } from "./account-info.model"
import { Merchant } from "./merchants.model"
import { TransactionCategory } from "./transaction-category.model"

export interface TransactionDetail {
  transactionCurrency: string
  transactionCat: string
  merchantId: string
  dbcrFlag: string
  transactionAmount: number
  transactionRef: string
  transactionDate: string
  transactionDesc: string
  transactionRemarks: string
  merchantData?: Merchant
  transactionCodeData?: TransactionCategory
}

export interface AccTranDetails extends AccountDetails{
  transactionDetails?: TransactionDetail[],
  flexPayTrxList?: []
}

export interface TransactionInfo {
  beneficiaryBank: string
  transactionCurrency: string
  transactionStatus: string
  executionDate: string
  payerBankName: string
  transactionRef: string
  valueDate: string
  transactionDesc: string
  transactionRemarks: string
  payerAccount: string
  beneficiaryBIC: string
  merchantId: string
  payerBankBIC: string
  beneficiaryName: string
  dbcrFlag: string
  beneficiaryAccount: string
  transactionAmount: number
  paymentMethod: string
  payerName: string
}